// extracted by mini-css-extract-plugin
export default {"container":"geral_container__qwDAB","geralList":"geral_geralList__9BQSB","tabela":"geral_tabela__psHrL","relatorios":"geral_relatorios__8jENw"};